// extracted by css-extract-rspack-plugin
export default {"handle":"ComposerResizeHandle-module__handle__WcR4j","resizing":"ComposerResizeHandle-module__resizing__CWqul"};